
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AnimatedOilDrop from './AnimatedOilDrop';

const HeroSection = () => {
  const handleSearch = (query: string) => {
    console.log('Search query:', query);
    // In a real app, this would redirect to search results
  };

  return (
    <div className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-autocare-blue to-autocare-blue-dark">
      {/* Abstract shapes background */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute top-1/4 -left-10 w-40 h-40 bg-autocare-yellow rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-1/4 w-60 h-60 bg-white rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 right-10 w-40 h-40 bg-autocare-yellow rounded-full blur-3xl"></div>
      </div>

      <div className="page-container relative z-10 pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white stagger-animate-slide">
            <span className="inline-block px-3 py-1 font-semibold uppercase tracking-wide bg-white/10 rounded-full backdrop-blur-sm mb-6 text-base">
              سيارتك تستحق الأفضل
            </span>
            {/* Main Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              اعثر على <span className="text-autocare-yellow">تغيير الزيت</span> المثالي لمركبتك
            </h1>
            {/* Supporting Headline - now matching the style above */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8">
              نحن <span className="text-autocare-yellow">نهتم</span> بـ<span className="text-autocare-yellow">سيارتك</span>
            </h1>

            {/* SearchBar removed from here */}

            <div className="flex flex-wrap gap-4">
              <Link to="/oil-finder" className="btn-secondary flex items-center">
                <span>اعثر على زيتك</span>
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link to="/shops" className="btn-outline border-white text-white hover:bg-white/10 hover:text-white">
                تصفح المحلات
              </Link>
            </div>

            <div className="flex items-center space-x-8 mt-12">
              <div className="flex flex-col">
                <span className="text-3xl font-bold">20+</span>
                <span className="text-sm mt-1 opacity-80">محل خدمة</span>
              </div>
              <div className="flex flex-col">
                <span className="text-3xl font-bold">50+</span>
                <span className="text-sm mt-1 opacity-80">نوع زيت</span>
              </div>
              <div className="flex flex-col">
                <span className="text-3xl font-bold">3K+</span>
                <span className="text-sm mt-1 opacity-80">سائق راضٍ</span>
              </div>
            </div>
          </div>

          <div className="relative flex justify-center">
            <div className="relative w-full max-w-lg">
              {/* Car image with glowing effect */}
              <div className="relative z-10 animate-float">
                <img alt="صيانة السيارة" className="rounded-2xl shadow-2xl" src="https://i.pinimg.com/736x/5c/f0/09/5cf0093d4cb05d924d6a942f84c45993.jpg" />
                <div className="absolute -inset-0.5 bg-gradient-to-r from-autocare-yellow/50 to-autocare-blue-light/50 rounded-2xl blur-lg opacity-70 -z-10"></div>
              </div>

              {/* Dynamic oil drop animation */}
              <div className="absolute -bottom-10 -right-10 w-48 h-48 z-20">
                <AnimatedOilDrop />
              </div>

              {/* Floating accent elements */}
              <div className="absolute top-5 -right-8 bg-autocare-yellow p-4 rounded-lg shadow-lg animate-float glass-card z-20 opacity-90 backdrop-blur-md">
                <div className="text-autocare-blue">
                  <div className="font-semibold">موعد تغيير الزيت</div>
                  <div className="text-sm">التالي: أسبوعان</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
